import Dashboard from "@mui/icons-material/Dashboard";
import Input from "@mui/icons-material/Input";
import People from "@mui/icons-material/People";
import ListAlt from "@mui/icons-material/ListAlt";
import InsertChartOutlined from "@mui/icons-material/InsertChartOutlined";
import MenuBookIcon from '@mui/icons-material/MenuBook';

// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import UserProfile from "views/UserProfile/UserProfile.js";
import LogoutPage from "views/LoginPage/LogoutPage.jsx";
import Captura from "views/Invex/Captura.jsx";
import ReporteCalidad from "views/Invex/ReporteCalidad";
import Calificacion from "views/Dashboard/Calificacion";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
    id: 10
  },
  {
    path: "/usuarios",
    name: "Usuarios",
    icon: People,
    component: UserProfile,
    layout: "/admin",
    id: 11
  },
  {
    path: "/calidad",
    name: "Calidad",
    icon: ListAlt,
    component: Captura,
    layout: "/admin",
    id: 12
  },
  {
    path: "/reportecalidad",
    name: "Reporte Calidad",
    icon: InsertChartOutlined,
    component: ReporteCalidad,
    layout: "/admin",
    id: 13
  },
  {
    path: "/calificacion",
    name: "Calificación",
    icon: MenuBookIcon,
    component: Calificacion,
    layout: "/admin",
    id: 16
  },
  {
    path: "/logout",
    name: "Cerrar Sesión",
    icon: Input,
    component: LogoutPage,
    layout: "/admin",
    id: 0
  }
];

export default dashboardRoutes;